module.exports = __webpack_public_path__ + "static/img/Eight of Swords.4cb4bb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Eight of Swords.jpg
// module id = 1263
// module chunks = 0